module.exports = __webpack_public_path__ + "img/04_En.55003492.png";